import {VGModal} from "../../../../../modules/index.esm";
import ageLimit from "./ageLimit";

window.Catalog = {
	setUrlData: function (url) {
		history.pushState({}, null, url)
	},
	reload: function () {
		let $form = $("#form-catalog");

		let route = location.href
		let params = $form.serializeArray();

		$([document.documentElement, document.body]).animate({
			scrollTop: $('.catalog-page').offset().top + 50
		}, 500);

		$.get(route, params, function (data) {
			if (data.view) {
				let $content = $('.catalog-content');
				$content.html(data.view);

				let $b = $('section.breadcrumbs');
				$b.after(data.breadcrumbs)
				$b.remove();

				if (data.age_limit) {
					$content.addClass('with-age-limit');
				} else {
					$content.removeClass('with-age-limit');
				}

				$('title').text(data.title);

				ageLimit();

				setTimeout(function () {
					let $btnModal = $('.catalog-content').find('[data-vg-toggle="modal"]');
					if ($btnModal.length) {
						for (let $btn of $btnModal) {
							$btn.onclick = function () {
								VGModal.init(this);
								return false;
							};
						}
					}
				}, 1000)
			}
		});

		$('.catalog-sidebar.catalog-sidebar-mobile.open').trigger('click')
	},
};

$(document).on('click', '[data-load-category]', function () {
	let url = $(this).attr('href');

	let $catalogCategories = $(this).closest('.catalog-categories');
	$catalogCategories.find('li.active').removeClass('active');
	$(this).closest('li').addClass('active');

	Catalog.setUrlData(url);
	Catalog.reload();

	return false;
});

$(document).on('change', '.catalog-filter', function () {
	Catalog.reload();

	return false;
});
